<template>
  <article class="db-media-card">
    <div class="db-media-card-img" role="button" tabindex="0" :aria-label="'Editar ' + popuptitle" @click="editar" @keydown.enter="editar">
      <img v-img-fallback v-if="getImage" :src="getImage" :alt="popuptitle" loading="lazy" />
      <span v-else class="db-media-card-placeholder">
        <span class="material-symbols-outlined">image</span>
      </span>
      <span class="db-badge" :class="estado.clase">
        <span class="material-symbols-outlined">{{ estado.icon }}</span> {{ estado.texto }}
      </span>
    </div>

    <div class="db-media-card-body">
      <h3 class="db-media-card-title">{{ popuptitle }}</h3>
      <span class="db-media-card-meta">{{ resumenFechas }}</span>
      <span v-if="url" class="db-media-card-meta cp-url">
        <span class="material-symbols-outlined">link</span> {{ url }}
      </span>
    </div>

    <div class="db-media-card-actions">
      <button type="button" class="db-btn db-btn--ghost db-btn--sm" @click="editar">
        <span class="material-symbols-outlined">edit</span> Editar
      </button>
      <button
        type="button"
        class="db-icon-btn db-icon-btn--danger"
        title="Eliminar aviso"
        aria-label="Eliminar aviso"
        @click="$emit('eliminarPopUp', { id })"
      >
        <span class="material-symbols-outlined">delete</span>
      </button>
    </div>
  </article>
</template>

<script>
import { toISODate, formatFecha } from "@/directives/dbDialogs.js";

export default {
  name: "CardPopUp",
  props: ["imageSrc", "popuptitle", "id", "fechas", "url"],
  data() {
    return {
      base: this.$media,
    };
  },
  computed: {
    getImage() {
      if (!this.imageSrc) return null;
      return this.imageSrc.includes("http") ? this.imageSrc : `${this.base}/img/minGallery/${this.imageSrc}`;
    },
    listaFechas() {
      return (this.fechas || "")
        .split(",")
        .map((f) => f.trim())
        .filter(Boolean)
        .sort();
    },
    estado() {
      const hoy = toISODate(new Date());
      if (this.listaFechas.includes(hoy)) return { texto: "Activo hoy", clase: "db-badge--success", icon: "radio_button_checked" };
      if (this.listaFechas.some((f) => f > hoy)) return { texto: "Programado", clase: "db-badge--info", icon: "event_upcoming" };
      return { texto: "Caducado", clase: "", icon: "event_busy" };
    },
    resumenFechas() {
      const n = this.listaFechas.length;
      if (!n) return "Sin fechas";
      const hoy = toISODate(new Date());
      const proxima = this.listaFechas.find((f) => f >= hoy);
      const base = `${n} día${n === 1 ? "" : "s"}`;
      return proxima ? `${base} · próximo: ${formatFecha(proxima, { corta: true })}` : `${base} · último: ${formatFecha(this.listaFechas[n - 1], { corta: true })}`;
    },
  },
  methods: {
    editar() {
      this.$emit("editPopUp", { id: this.id });
    },
  },
};
</script>

<style scoped>
.cp-url {
  display: flex;
  align-items: center;
  gap: 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.cp-url .material-symbols-outlined {
  font-size: 15px;
}
</style>
